import React from "react";

const HealthCheck = () =>{
    return(
        <div>HealthCheckPublicRoute</div>
    )
}


export default HealthCheck;